module.exports = __webpack_public_path__ + "static/img/rank_background2_official.1f8be70e.png";